import { useCallback, useState } from 'react';

// useOnDemandPanel tracks which on-demand panels (Pools, Deck
// Inspector) are currently open. Returns { isOpen, open, close, toggle }
// for a single panel name.
//
// Multiple panels can be opened at once if needed; each hook instance
// is independent.
export function useOnDemandPanel(_panelName) {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen(prev => !prev), []);
    return { isOpen, open, close, toggle };
}
